import axios from "axios";
import { API } from "../../Backend";
import {
    ADD_TO_CART_FAIL,
    ADD_TO_CART_REQUEST,
    ADD_TO_CART_SUCCESS,
    DELETE_ITEM_REQUES,
    CLEAR_ERRORS
} from "../constants/cartConstant"

export const addToCart = (product, quantity) => async(dispatch, getState) => {
        const data = {
            ...product,
            quantity: quantity,
            option1_name: product.option1_name,
            option2_name: product.option2_name,
        }
        dispatch({type: ADD_TO_CART_REQUEST, payload: data})
        localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems))
}

export const deleteItem = (id) => async(dispatch, getState) => {
    console.log(id)
    dispatch({type: DELETE_ITEM_REQUES, payload: id})
    localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems))
}

// Used for cleaning errors
export const clearErrors = () => async(dispatch) => {
    dispatch({type: CLEAR_ERRORS})
}